import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const INACTIVITY_TIMEOUT = 20 * 60 * 1000;
const CHECK_INTERVAL = 2 * 60 * 1000;
const DEBOUNCE_DELAY = 500;

export const useInactivityMonitor = (isSbTeam) => {
    const [lastActivity, setLastActivity] = useState(Date.now());
    const { logout } = useAuth0();

    useEffect(() => {
        if (isSbTeam) return;
        let inactivityTimer;
        let debounceTimer;

        const resetTimer = () => {
            setLastActivity(Date.now());
        };

        const debouncedResetTimer = () => {
            console.log('Event detected');
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                resetTimer();
            }, DEBOUNCE_DELAY);
        };

        const checkInactivity = () => {
            const currentTime = Date.now();
            const timeSinceLastActivity = currentTime - lastActivity;

            if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
                localStorage.clear();
                logout({ returnTo: window.location.origin });
            }
        };

        window.addEventListener('mousedown', debouncedResetTimer);

        const intervalTimer = setInterval(checkInactivity, CHECK_INTERVAL);

        return () => {
            window.removeEventListener('mousedown', debouncedResetTimer);
            clearInterval(intervalTimer);
            clearTimeout(inactivityTimer);
            clearTimeout(debounceTimer);
        };
    }, [lastActivity, logout]);

    const resetInactivityTimer = () => {
        if (!isSbTeam) {
            setLastActivity(Date.now());
        }
    };

    return { resetInactivityTimer };
};
